import React from 'react';

const LogoutIcon = ({ size = 22, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M15.1016 16.4366C14.7916 20.0366 12.9416 21.5066 8.89156 21.5066H8.76156C4.29156 21.5066 2.50156 19.7166 2.50156 15.2466V8.73656C2.50156 4.26656 4.29156 2.47656 8.76156 2.47656H8.89156C12.9116 2.47656 14.7616 3.92656 15.0916 7.46656"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00281 12H20.3828"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.15 15.3484L21.5 11.9984L18.15 8.64844"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LogoutIcon;
